import { IonRouterLink } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

import DateStamp from '@components/dates/DateStamp';
import styles from '@components/profile/Profile.module.css';
import Icon from '@components/text/Icon';
import BodyCopy from '@components/typography/BodyCopy';
import useMyExpert from '@hooks/useMyExpert';
import { GetJourneyWithCareProfileQuery } from '@typing/Generated';
import { sortByTimestamp } from '@utils/modelUtils';
import { journeyRoute } from '@utils/routeUtils';

type Props = {
  journey: GetJourneyWithCareProfileQuery['journey'];
};

const ExpertReports = ({ journey }: Props) => {
  const myExpert = useMyExpert();
  const consultsWithReports = sortByTimestamp(
    journey.consults.filter(consult => consult.consultReport?.published),
    consult => consult.consultReport?.publishedAt
  );

  return (
    <div className={styles.reports}>
      {consultsWithReports.map(consult => (
        <IonRouterLink
          key={consult.id}
          routerLink={journeyRoute({
            journeyId: journey.id,
            linkAfterJourney: `/consults/${consult.id}/consult-report`,
            myExpert
          })}
        >
          <div className={styles.report}>
            <div>
              <BodyCopy color="neutral500" underline>
                <FormattedMessage
                  id="pages.carePlan.base.expert.consultReport"
                  values={{ date: <DateStamp value={consult.startTime} /> }}
                />
              </BodyCopy>
            </div>
            <Icon ariaLabelKey="accessibility.ariaLabels.open" className={styles.open} icon="chevronRight" />
          </div>
        </IonRouterLink>
      ))}
      {journey.initialConsultReport.publishedAt && (
        <IonRouterLink
          routerLink={journeyRoute({
            journeyId: journey.id,
            linkAfterJourney: `/initial-consult-report`,
            myExpert
          })}
        >
          <div className={styles.report}>
            <div>
              <BodyCopy color="neutral500" underline>
                <FormattedMessage
                  id="pages.carePlan.base.expert.initialConsultReport"
                  values={{
                    date: (
                      <DateStamp
                        value={
                          journey.initialConsultReport.consult?.startTime ?? journey.initialConsultReport.publishedAt
                        }
                      />
                    )
                  }}
                />
              </BodyCopy>
            </div>
            <Icon ariaLabelKey="accessibility.ariaLabels.open" className={styles.open} icon="chevronRight" />
          </div>
        </IonRouterLink>
      )}
    </div>
  );
};

export default ExpertReports;
